// JOBE-0167.5: HealthTabBody — v1 placeholder card.
//
// Per umbrella JOBE-0167's Out of scope (D19 deferral), the full Health
// dashboard is deferred. v1 ships a placeholder card with three "pending
// JOBE-XXXX" TODO lines so the tab exists (the tab bar can't skip the
// slot or future designs lose their seam) but doesn't claim functionality
// it lacks.

import { Card } from '../../components/Card/Card.jsx';

export function HealthTabBody() {
  return (
    <div className="health-body" data-testid="health-body">
      <Card className="health-body__card" data-testid="health-placeholder-card">
        <div className="health-body__card-inner">
          <header className="health-body__header">Memory health · placeholder</header>
          <p>
            This dashboard is deferred per JOBE-0167's Out of scope. v1 makes
            the tab present so the slot exists; a follow-up spec will fill it.
          </p>
          <div className="health-body__pending">
            <div className="health-body__pending-label">Pending:</div>
            <ul>
              <li data-testid="health-pending-item">Substrate health · pending JOBE-XXXX</li>
              <li data-testid="health-pending-item">Supersession-chain depth distribution · pending JOBE-XXXX</li>
              <li data-testid="health-pending-item">Consolidation-run latency · pending JOBE-XXXX</li>
            </ul>
          </div>
          <footer className="health-body__see">
            See: docs/proposals/jobe-webui-workforce-navigation/decisions.md §D19 (deferred items).
          </footer>
        </div>
      </Card>
    </div>
  );
}

export default HealthTabBody;
